import React from 'react';

import { IconFunctionalInformationCircle16, InformationTooltip, UIText2 } from '@cian/ui-kit';
import { PskTooltipContent } from '../../components/PskTooltipContent';
import { OfferCard } from '../../components/OfferCard';
import { ActionsContainer } from '../ActionsContainer';
import { IOffer } from '../../types';

import * as styles from './styles.css';
import { ETestIds } from '../../constants';

export interface IListingContainerProps {
  onCardClick: (offer: IOffer) => () => void;
  offerList: IOffer[];
}

export const DesktopListingContainer: React.FC<IListingContainerProps> = ({ onCardClick, offerList }) => {
  return (
    <div className={styles['container']} data-testid={ETestIds.DesktopListing}>
      <div className={styles['heading']}>
        <div className={styles['heading__wrapper']}>
          <div className={styles['tooltip__container']}>
            <UIText2 color={'text-secondary-default'}>Полная стоимость кредита</UIText2>
            <div onClick={e => e.stopPropagation()}>
              <InformationTooltip
                placement={'right-start'}
                content={<PskTooltipContent />}
                header={'Полная стоимость кредита'}
              >
                <div className={styles['tooltip']} data-testid={ETestIds.PskTooltip}>
                  <IconFunctionalInformationCircle16 color={'icon-secondary-default'} cursor="pointer" />
                </div>
              </InformationTooltip>
            </div>
          </div>
          <UIText2 color={'text-secondary-default'}>Ставка</UIText2>
          <UIText2 color={'text-secondary-default'}>Платёж</UIText2>
        </div>
      </div>
      <div className={styles['listing']}>
        {offerList.map((offer, index) => {
          return (
            <div key={index} className={styles['listing__card']}>
              <OfferCard offer={offer} onClick={onCardClick(offer)} />
            </div>
          );
        })}
      </div>
      <ActionsContainer />
    </div>
  );
};
